import { sendIncrementMetric } from '@loomhq/loom-js-statsd/frontend';

export const incrementMetric = (name, tags = {}) => {
  sendIncrementMetric({ name, tags });
};
